import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import './Navibar.css';
import { useState } from 'react';


const Navibar = ()=> {
  const [expanded, setExpanded ] = useState(false);
  return (
    <>
      <Navbar expand='md' id="nav-bar" sticky="top" expanded={expanded}>       
        <Container id="self">
          <Navbar.Brand href="#home-unit" id="brand">Luwam!</Navbar.Brand>
          <Navbar.Toggle onClick={() => setExpanded(true)} aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="center" id="nav-links-unit">
            <Nav.Link onClick={() => setExpanded(false)} href="#home-unit" id="nav-links">Home</Nav.Link>
            <Nav.Link onClick={() => setExpanded(false)} href="#projects" id="nav-links">Projects</Nav.Link>
            <Nav.Link onClick={() => setExpanded(false)} href="#contact-unit" id="nav-links" className="nav-link-contact">Contact</Nav.Link>
          </Nav>

        </Navbar.Collapse>
          <div id="icons-unit">
          <a href="https://github.com/CodeWithLuwam" target="_blank" rel="noreferrer">  <BsGithub size="2em" id="icon"/> </a>
          <a href="https://www.linkedin.com/in/luwam-ghebremicael/" target="_blank" rel="noreferrer">  <BsLinkedin size="2em" id="second-icon"/> </a>
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default Navibar;